<template>
  <div id="state">
    <!-- 手机端 -->
    <div class="phone" v-if="flag == 2">
      <state_dialog v-if="dialogData.flag" :myDialogData="dialogData">
      </state_dialog>
    </div>

    <!-- PC端 -->
    <div class="PC" v-if="flag == 1">
      <state_dialog_PC v-if="dialogData.flag" :myDialogData="dialogData">
      </state_dialog_PC>
    </div>
  </div>
</template>

<script>
import * as stateData from "./state.js";
export default {
  data() {
    return {
      flag: 0,
      dialogData: {
        flag: false,
        title: "忘记密码",
        data: [],
        stateNameOne: "验证身份",
        stateNameTwo: "重置密码",
        stateInfo: "您的密码重置成功",
        statebtnName: "返回登录",
      },
    };
  },
  methods: {
    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;

        this.met();
      } else {
        // this.flag = 2;
        // this.met();
        this.$message({
          type: "warning",
          message: "请用电脑端查看!",
        });
        return;
      }
    },
    met() {
      this.dialogData.flag = true;
      this.dialogData.data = stateData.getstateDialogData();
    },
  },
  mounted() {
    this.start();
  },
};
</script>

<style lang="less" scoped>
#state {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .phone {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .PC {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(245, 245, 245, 1);
  }
}
</style>
